import { EnvironmentDecoderAdapter } from '@/infra/criptography'

export const makeEnvironmentDecoderAdapterFactory = (): EnvironmentDecoderAdapter => new EnvironmentDecoderAdapter()
